// extracted by mini-css-extract-plugin
export default {"tag":"index_tag_wDUwM","btn":"index_btn_6-Wlj","btn1":"index_btn1_hNo8d","text_wrap":"index_text_wrap_nLYdO"};